@if (samePeriod) {
  <span>{{ month | translate }} {{ year }}</span>
}
@if (!samePeriod) {
  <div>
    <app-date-box [value]="dataContext.periodFrom"></app-date-box> - <app-date-box [value]="dataContext.periodTo"></app-date-box>
  </div>
}
